export default {
  dark: 'Dunkel',
  light: 'Hell',
};
